import {
  PublicClientApplication,
  Configuration,
  AccountInfo,
} from "@azure/msal-browser";
import appConfig from "../config/appConfig.ts";
import { MICROSOFT_LOGIN_URL } from "../constants/constants.ts";

class AuthService {
  private static instance: AuthService;
  private azureConfig: any;
  private msalInstance: PublicClientApplication | null = null;

  private constructor() {}

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  public async loadAppConfig() {
    const res = await fetch("/api/config");
    if (!res.ok) {
      throw Error("Could not get app config");
    }
    const data = await res.json();

    appConfig.SERVER_API_URL = data.serverApiUrl;
    appConfig.MANAGER_WEBSITE_BASE_URL = data.managerWebsiteUrl;
    appConfig.FRONTEND_WEBSITE_BASE_URL = data.frontendWebsiteUrl;
  }

  public async loadAzureConfig() {
    let company = localStorage.getItem("company");
    if (!company) {
      throw Error("No Company available");
    }
    await this.loadAzureConfigByCompany(company);
  }
  public async loadAzureConfigByCompany(company: string) {
    if (this.azureConfig) {
      return;
    }
    try {
      let res = await fetch(
        `${appConfig.SERVER_API_URL}/AdminLogin/AzureConfig`,
        {
          headers: {
            "X-Company": company,
          },
        }
      ).then((res) => res.json());

      this.azureConfig = res;
    } catch {
      throw Error("Could not get Azure Config");
    }
  }

  public async initializeMsalClient() {
    try {
      const msalConfig: Configuration = {
        auth: {
          clientId: this.azureConfig.clientId,
          authority: `${MICROSOFT_LOGIN_URL}/${this.azureConfig.tenantId}`,
          redirectUri: appConfig.MANAGER_WEBSITE_BASE_URL,
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: true,
        },
      };
      this.msalInstance = new PublicClientApplication(msalConfig);
    } catch (Exception) {
      throw Error("Could not initialize Msal config");
    }
  }

  public async login() {
    await this.msalInstance!.initialize();
    try {
      await this.msalInstance!.loginPopup({
        prompt: "select_account",
        scopes: ["user.read"],
      });
    } catch (error) {
      throw Error("Could not log in");
    }
  }

  public async getToken(): Promise<string | null> {
    if (!this.msalInstance) return null;
    try {
      await this.msalInstance.initialize();
      const accounts: AccountInfo[] = this.msalInstance.getAllAccounts();
      const response = await this.msalInstance.acquireTokenSilent({
        scopes: ["user.read"],
        account: accounts[0],
      });
      return response.idToken;
    } catch (err) {
      return null;
    }
  }

  public async logout(): Promise<void> {
    localStorage.removeItem("company");
    if (this.msalInstance) {
      this.msalInstance.logoutPopup();
    }
    this.azureConfig = null;
  }
}

export default AuthService;
